export default {
  Africa: 'rgb(208, 222, 255)',
  Asia: 'rgb(209, 240, 252)',
  'Australia and Oceania': 'rgb(194, 246, 232)',
  Europe: 'rgb(254, 233, 182)',
  'North America': 'rgb(253, 226, 210)',
  'Latin America': 'rgb(255, 218, 245)',
}
